import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

import cssVars from 'css-vars-ponyfill';

import { setThemeConfig, BluestoneTheme, setIconConfig } from '@sds/core';

import { defineAllElements } from '@sds/custom-elements';
import { bluestoneIcons, materialBaselineIcons, materialOutlineIcons } from '@sds/icons';

setThemeConfig(BluestoneTheme);
defineAllElements();

setIconConfig({
    basePath: 'assets/icons',
    defaultPack: 'bluestone',
    packs: [
        { name: 'bluestone', icons: bluestoneIcons },
        { name: 'materialOutline', icons: materialOutlineIcons},
        { name: 'materialBaseline', icons: materialBaselineIcons},
        {
          name: 'alertingIcons',
          variant: 'alerting',
          icons: {
            'server': '../server.svg'
          }
        },
    ]
});

cssVars();

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error()); // eslint-disable-line no-console
